<template>
  <b-container>
     <b-card>
      <FormPrivacyLgpd :id="id" @setFormLgpd="updateFormLgpd"></FormPrivacyLgpd>

      <b-row class="pt-2">
        <b-col md="12">
          <media-list :medias="handlingFiles" :show-delete="false" :action-on-click="false"/>
        </b-col>
      </b-row>

      <div class="mt-1 mb-2">
        <div class="flex justify-end">
          <b-button
            v-permission="`privacy_form.handling`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1 float-right"
            @click="handlingForm()">
              {{$t('handling_form')}}
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            class="mt-1 mr-1 float-right"
            @click="$router.push('/privacy-form')">
              {{$t('back')}}
          </b-button>
        </div>
      </div>

     </b-card>
  </b-container>
</template>

<script>

import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BTable,
  BButton,
  VBTooltip
} from 'bootstrap-vue'

import FormPrivacyLgpd from './FormPrivacyLgpd'
import MediaList from '@/components/media/MediaList.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    FormPrivacyLgpd,
    MediaList,
    BContainer,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    requestForm: null,
    handlingFiles: [],
    services: {

    },
  }),
  methods: {
    updateFormLgpd(formData) {
      this.requestForm = formData
      this.handlingFiles = _.get(formData, 'request_form_handling.files', [])
    },
    handlingForm() {
      this.$router.push(`/privacy-form/${this.id}/handling`)
    },
  },
  mounted() {

  },
  beforeMount() {

  }
}
</script>
